/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "banking": {
        "nested": {
          "PartialAccount": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "type": {
                "type": "squareup.banking.AccountType",
                "id": 2,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "owner": {
                "type": "squareup.banking.Owner",
                "id": 4,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banking?.nested?.PartialAccount) {
  $root.addJSON(jsonData);
}

/**
 * Simplified view of a partial_account. Contains partial fields of an Account.
 * Used to denote a partial Account when certain fields on banking.Account are not populated
 * due to unavailability of a downstream service.
 *
 * SOURCE PartialAccount @ squareup/banking/partial_account_model.proto at 15:1
 */
export const PartialAccount = $root.lookupType('squareup.banking.PartialAccount');
fixType(PartialAccount);
Builder.createAndAttachToType(PartialAccount);